import React from 'react';
import PropTypes from 'prop-types';
import { IconBlock, Icon } from 'anf-core-react';

const IconBlockDisplay = ({ storeName }) => (
  <IconBlock orientation="horizontal" icon={(<Icon icon="location-outline" size="s" />)}>
    <h2 className="h4 single-store__info-name">
      {storeName}
      <meta itemProp="name" content={storeName} />
    </h2>
  </IconBlock>
);

IconBlockDisplay.propTypes = {
  storeName: PropTypes.string.isRequired,
};

export default IconBlockDisplay;
